import moment from 'moment'
import axiosSmartSurvey from '../../../api/axios'
import useAuth from '../../../hooks/useAuth'

export default function useFetchWasteFee() {
    const { user } = useAuth()
    async function submitSearch(parcelCode, address, route, houseName, setWasteFeeDataList) {
        console.log(parcelCode, address, route, houseName,)
        if (parcelCode === '') {
            parcelCode = undefined
        }
        if (address === '') {
            address = undefined
        }
        if (route === '') {
            route = undefined
        }
        if (houseName === '') {
            houseName = undefined
        }
        await axiosSmartSurvey({
            method: 'post',
            url: '/wastefee/searchdata',
            data: {
                parcelCode: parcelCode,
                address: address,
                route: route,
                houseName: houseName,
            }
        }).then((response) => {
            if (response.data.status === 'OK') {
                response = response.data.wasteFeeData
                setWasteFeeDataList(response)
            } else {
                // console.log(response)
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const axiosWasteFeeDataList = async (setWasteFeeDataList,) => {
        var response = await axiosSmartSurvey({
            method: 'post',
            url: '/wastefee/datatable'
        })
        // console.log(response)
        response = response.data.wasteFeeData
        setWasteFeeDataList(response)
    }
    const fetchDeleteWasteFeeData = async (handleDeleteDialogClose, wasteFeeId, statusChangedNote) => {
        await axiosSmartSurvey({
            method: 'post',
            url: `/wastefee/deletewastefeedata`,
            data: {
                rowId: wasteFeeId,
                statusChangedNote: statusChangedNote
            }
        }).then((response) => {
            // console.log(response)
            handleDeleteDialogClose()
        }).catch((err) => {
            console.log(err)
        })
    }

    async function onFetchEditInput(rowId, setWasteFeeData, setBackDropLoading) {
        setBackDropLoading(true)
        await axiosSmartSurvey({
            method: 'post',
            url: '/wastefee/editinputdata',
            data: {
                id: rowId,
            }
        }).then((response) => {
            // console.log(response)
            if (response.data.status === 'OK') {
                response = response.data.data
                setWasteFeeData({
                    parcelCode: response.parcel_code || '',
                    houseName: response.house_name || '',
                    houseCode: response.house_code || '',
                    address: response.address || '',
                    route: response.route || '',
                    road: response.road || '',
                    soi: response.soi || '',
                    moo: response.moo || '',
                    tumbol: response.tumbol_id || 0,
                    fee: response.fee || '',
                    note: response.note || '',
                })
                // console.log(response.data)
            } else {
                console.log(response.data)
            }
        }).catch((err) => {
            console.log(err)
        })
        setBackDropLoading(false)
    }
    function addWasteFeeData(wasteFeeData, setDefaultWasteFeeData, setAddModalOpen, setSuccessAlertOpen, setErrorAlertOpen, setSuccessText, setErrorText) {
        // console.log(wasteFeeData)
        axiosSmartSurvey({
            method: 'post',
            url: '/wastefee/addwastefeedata',
            data: {
                wasteFeeData: wasteFeeData,
                user: user
            }
        }).then((response) => {
            if (response.data.status === 'OK') {
                // console.log(response)
                setSuccessAlertOpen(true)
                setSuccessText(response.data.message)
                setAddModalOpen(false)
                setDefaultWasteFeeData()
            } else {
                console.log(response)
                setErrorAlertOpen(true)
                setErrorText(response.data.message)
            }
        })
    }
    function editWasteFeeData(wasteFeeData, setDefaultWasteFeeData, setAddModalOpen, setSuccessAlertOpen, setErrorAlertOpen, setSuccessText, setErrorText, rowId) {
        axiosSmartSurvey({
            method: 'post',
            url: '/wastefee/editwastefeedata',
            data: {
                wasteFeeData: wasteFeeData,
                rowId: rowId,
                user: user
            }
        }).then((response) => {
            if (response.data.status === 'OK') {
                console.log(response)
                setSuccessAlertOpen(true)
                setSuccessText(response.data.message)
                setAddModalOpen(false)
                setDefaultWasteFeeData()
            } else {
                console.log(response)
                setErrorAlertOpen(true)
                setErrorText(response.data.message)
            }
        })
    }
    const fetchPaymentData = async (id, budgetYear, monthPaymentStatus, setMonthPaymentStatus, setYearPayment) => {
        // console.log(monthPaymentStatus)
        await axiosSmartSurvey({
            method: 'post',
            url: `/wastefee/paymentdata`,
            data: {
                id: id,
                budgetYear: budgetYear
            }
        }).then(async (response) => {
            response = response.data
            console.log(response?.paymentMonthStatus?.length > 0)
            if (response?.paymentMonthStatus?.length > 0) {
                setYearPayment(false)
            } else {
                setYearPayment(true)
            }
            var arr = monthPaymentStatus
            await monthPaymentStatus?.forEach((data, index) => {
                arr[index].paid = response.paymentMonthStatus.includes(data.monthNo)
            })
            // console.log(arr)
            setMonthPaymentStatus(arr)
        }).catch((err) => {
            console.log(err)
        })
    }
    async function fetchReceipt(rowId, monthNo, setReceiptViewData) {
        // console.log(rowId, monthNo)
        await axiosSmartSurvey({
            method: 'post',
            url: '/wastefee/receiptdata',
            data: {
                wastefeeId: rowId,
                monthNo: monthNo
            }
        }).then((response) => {
            response = response.data
            // console.log(response.receipts[0])
            setReceiptViewData(response.receipts[0])
        }).catch((err) => {
            console.log(err)
        })
    }
    async function fetchEditReceipt(rowId, monthNo, addReceiptData, setAddReceiptData) {
        // console.log(rowId, monthNo)
        await axiosSmartSurvey({
            method: 'post',
            url: '/wastefee/receiptdata',
            data: {
                wastefeeId: rowId,
                monthNo: monthNo
            }
        }).then((response) => {
            response = response.data
            // console.log(response.receipts[0])
            const receipt = response.receipts[0]
            setAddReceiptData({
                ...addReceiptData,
                id: receipt.id,
                receiptNo: receipt.receipt_no,
                totalFee: receipt.total_fee,
                receiptDate: receipt.receipt_date,
                note: receipt.note
            })
        }).catch((err) => {
            console.log(err)
        })
    }
    async function addWasteFeeReceipt(addReceiptData, rowId, budgetYear, monthNo,
        setSuccessAlertOpen, setSuccessText, setErrorAlertOpen, setErrorText) {
        // console.log(addReceiptData, rowId, budgetYear, monthNo, user)
        await axiosSmartSurvey({
            method: 'post',
            url: '/wastefee/addreceipt',
            data: {
                addReceiptData: addReceiptData,
                wasteFeeId: rowId,
                budgetYear: budgetYear,
                monthNo: monthNo,
                user: user
            }
        }).then((response) => {
            response = response.data
            if (response?.status === 'OK') {
                setSuccessText('บันทึกข้อมูลสำเร็จ')
                setSuccessAlertOpen(true)
            } else {
                setErrorText(response?.statusText)
                setErrorAlertOpen(true)
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    async function addYearWasteFeeReceipt(addReceiptData, rowId, budgetYear,
        setSuccessAlertOpen, setSuccessText, setErrorAlertOpen, setErrorText) {
        await axiosSmartSurvey({
            method: 'post',
            url: '/wastefee/addyearreceipt',
            data: {
                addReceiptData: addReceiptData,
                wasteFeeId: rowId,
                budgetYear: budgetYear,
                user: user
            }
        }).then((response) => {
            response = response.data
            if (response?.status === 'OK') {
                setSuccessText('บันทึกข้อมูลสำเร็จ')
                setSuccessAlertOpen(true)
            } else {
                setErrorText(response?.statusText)
                setErrorAlertOpen(true)
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    async function editReceiptData(addReceiptData,
        setSuccessAlertOpen, setSuccessText, setErrorAlertOpen, setErrorText) {
        await axiosSmartSurvey({
            method: 'post',
            url: '/wastefee/editreceipt',
            data: {
                addReceiptData: addReceiptData,
                user: user
            }
        }).then((response) => {
            response = response.data
            if (response?.status === 'OK') {
                setSuccessText('แก้ไขข้อมูลสำเร็จ')
                setSuccessAlertOpen(true)
            } else {
                setErrorText(response?.statusText)
                setErrorAlertOpen(true)
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    async function fetchReportList(startDate, endDate, setReportList, setExcelExportData) {
        await axiosSmartSurvey({
            method: 'post',
            url: '/wastefee/fetchreportlist',
            data: {
                startDate: startDate,
                endDate: endDate
            }
        }).then((response) => {
            response = response.data
            console.log(response.results)
            var arr = [...response.results]
            arr.forEach((data, index) => {
                arr[index].receipt_date = moment(data.receipt_date).add(543, 'year').format('DD MMMM YYYY')
            })
            console.log(arr)
            setReportList(arr)
        }).catch((err) => {
            console.log(err)
        })
    }
    return {
        onFetchEditInput,
        submitSearch,
        axiosWasteFeeDataList,
        fetchDeleteWasteFeeData,
        fetchPaymentData,
        addWasteFeeData,
        editWasteFeeData,
        fetchReceipt,
        fetchEditReceipt,
        addWasteFeeReceipt,
        addYearWasteFeeReceipt,
        editReceiptData,
        fetchReportList
    }
}
